import { analytics } from "rtr-constants";
import PropTypes from "prop-types";
import { productPropType } from "components/propTypes";
import UserProductRatingsContainer from "../user_product_ratings/user-product-ratings-container";

function ComingSoonPDPContent({
  analyticsLoggingContext,
  isHeartEducationTooltipTriggered,
  location,
  product,
  setShowComingSoonShortList,
}) {
  return (
    <div data-test-id="coming-soon-pdp" className="pt-4 pb-3">
      <p className="text-lg font-medium pb-3">Available in the next 2 weeks</p>

      <p className="pb-4">
        {"Your first look at new arrivals. Heart your favorites so you can rent them as soon as they're available."}
      </p>

      <div>
        <UserProductRatingsContainer
          customHeartLoggingOptions={analyticsLoggingContext}
          isHeartEducationTooltipTriggered={isHeartEducationTooltipTriggered}
          product={product}
          location={location}
          // Note: This will be true as this component will only be rendered when isSaveToHearts is true
          isSaveToHearts={true}
          setShowComingSoonShortList={setShowComingSoonShortList}
        />
      </div>
    </div>
  );
}

ComingSoonPDPContent.propTypes = {
  analyticsLoggingContext: PropTypes.object,
  isHeartEducationTooltipTriggered: PropTypes.bool,
  location: PropTypes.oneOf([analytics.ACTION_LOCATIONS.DRAWER, analytics.ACTION_LOCATIONS.PDP]),
  product: productPropType,
  setShowComingSoonShortList: PropTypes.func,
};

export default ComingSoonPDPContent;
